import React from 'react';
import { AlertTriangle } from 'lucide-react';

/** Persistent banner for all /demo/* sandbox pages. */
export const DemoEnvironmentBanner: React.FC = () => (
  <div
    className="border-b border-amber-400 bg-amber-100 px-4 py-3 text-center text-sm text-amber-950"
    role="status"
    aria-live="polite"
  >
    <span className="inline-flex flex-col items-center justify-center gap-0.5 font-medium sm:flex-row sm:gap-2">
      <span className="inline-flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-800" aria-hidden />
        <span className="font-bold tracking-wide">DEMO ENVIRONMENT</span>
      </span>
      <span className="text-amber-900">— Simulated data only. Not connected to your live workspace.</span>
    </span>
  </div>
);

export default DemoEnvironmentBanner;
